<template>
  <div
    class="searchPopupContainer flexContainer yCenterContainer columnContainer"
  >
    <button
      @click="closePopup"
      class="closeButton mediumText"
      style="color: #000000"
    >
      x
    </button>
    <div style="width: 90%; height: 80%">
      <article-search
        class="smallText"
        style="height: 100%"
        origin="searchPopup"
        @form_update_notification="redirect"
      ></article-search>
    </div>
    <router-link
      class="mediumText"
      style="align-self: center; color: #ec783e"
      :to="nowhereUrl"
      @click.native="closePopup"
      >Nigdzie</router-link
    >
  </div>
</template>

<script>
import ArticleSearch from "../article/forms/search.vue";

export default {
  data() {
    return {
      nowhereUrl: "Pole poza pojęciami-35",
    };
  },
  methods: {
    redirect(receivedData) {
      let title = receivedData.articleTitle;
      let id = receivedData.articleId;
      if (this.$router.currentRoute.params["id"] !== title) {
        this.$router.push({
          name: "Article",
          params: { id: id, title: title },
        });
      }
      this.closePopup();
    },
    closePopup() {
      this.$store.dispatch("deletePopupMessage");
    },
  },
  components: {
    "article-search": ArticleSearch,
  },
};
</script>

<style scoped>
.searchPopupContainer {
  width: 30%;
  height: 40%;
  margin-top: 15%;
  margin-left: 34%;
  border: 2px solid #016d8f;
  background-color: #ffffff;
  justify-content: space-between;
  padding: 3%;
  box-shadow: 0 0 0 4px #ffffff, 0 0 0 6px #000000;
}

@media (max-width: 1000px) {
  .searchPopupContainer {
    margin-top: 15%;
    margin-left: 5%;
    width: 80%;
    height: 80%;
  }
}
</style>
